// Signup component for user registration
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [age, setAge] = useState('');
    const [favoriteColors, setFavoriteColors] = useState('');
    const [profilePicture, setProfilePicture] = useState(null);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        formData.append('name', name);
        formData.append('surname', surname);
        formData.append('age', age);
        formData.append('favorite_colors', favoriteColors);
        if (profilePicture) {
            formData.append('profile_picture', profilePicture); // Append profile picture if provided
        }

        try {
            const response = await axios.post('http://localhost:3000/api/auth/signup', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.status === 201) {
                alert('User created successfully. Please sign in.');
                navigate('/signin'); // Redirect to the sign-in page
            } else {
                alert('Error creating user. Please try again.');
            }
        } catch (error) {
            if (error.response) {
                alert(`Error signing up: ${error.response.data.message || error.response.statusText}`);
            } else if (error.request) {
                alert('No response received from server. Please try again.');
            } else {
                alert(`Error signing up: ${error.message}`);
            }
        }
    };

    const handleFileChange = (e) => {
        setProfilePicture(e.target.files[0]);
    };

    return (
        <div className="signup-page">
          <div className="signup-container">
            <div className="signup-form-box">
              <form onSubmit={handleSubmit}>
                <h1 className="signup-header"><strong>𝒮𝒾𝑔𝓃 𝒰𝓅</strong></h1>
                <div className="form-group">
                  <label><strong>E-mail</strong>*:</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="E-mail"
                    required
                  />
                </div>
                <div className="form-group">
                  <label><strong>Password</strong>*:</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                  />
                </div>
                <div className="form-group">
                  <label><strong>Name</strong>*:</label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your First Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label><strong>Surname</strong>*:</label>
                  <input
                    type="text"
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                    placeholder="Your Last Name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label><strong>Age</strong>:</label>
                  <input
                    type="number"
                    value={age}
                    onChange={(e) => setAge(e.target.value)}
                    placeholder="Your age (optional)"
                  />
                </div>
                <div className="form-group">
                  <label><strong>Favorite Colors</strong>:</label>
                  <input
                    type="text"
                    value={favoriteColors}
                    onChange={(e) => setFavoriteColors(e.target.value)}
                    placeholder="Favorite Colors (optional)"
                  />
                </div>
                <div className="form-group">
                  <label><strong>Profile Picture</strong>*:</label>
                  <input
                    type="file"
                    onChange={handleFileChange}
                    accept="image/*"
                    placeholder="Upload a profile picture"
                  />
                </div>
                <button type="submit" className="signup-button"><strong>𝒮𝒾𝑔𝓃 𝒰𝓅</strong></button>
              </form>
            </div>
            <div className="welcome-box">
              <h1><strong>Welcome to Digital Wardrobe!</strong></h1>
              <p>Join us and manage your wardrobe digitally and efficiently today!</p>
              <p>
                If you wish to learn more about us before signing up, please visit our <span onClick={() => navigate('/about-us')}>About Us</span> page.
              </p>
            </div>
          </div>
        </div>
    );
};
    
export default Signup;